import "clsx";
import { p as pop, a as push } from "../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../chunks/exports.js";
import "../../../chunks/utils.js";
import "../../../chunks/state.svelte.js";
function AdminNavbar($$payload, $$props) {
  push();
  $$payload.out.push(`<div class="m-5"><a href="/admin/product"><img src="/kLawLogo.png" alt="logo" class="h-10 md:h-12 lg:h-20"/></a></div> <header class="bg-fadeblack relative flex justify-between overflow-auto p-2 text-white"><button class="rounded-md p-2 transition-colors hover:bg-white/10 md:hidden" aria-label="Toggle menu"><i class="bi bi-list text-xl"></i></button> <nav class="hidden items-center md:flex"><ul class="flex space-x-5"><li class="hover:text-secondary ml-4 transition-colors"><a href="/admin/product">Products</a></li> <li class="hover:text-secondary transition-colors"><a href="/admin/order">Orders</a></li> <li class="hover:text-secondary transition-colors"><a href="/admin/promotions">Promotions</a></li> <li class="hover:text-secondary transition-colors"><a href="/admin/reports">Reports</a></li> <li class="hover:text-secondary transition-colors"><a href="/admin/legislation">Legislation</a></li> <li class="hover:text-secondary transition-colors"><a href="/admin/category">Categories</a></li> <li class="hover:text-secondary transition-colors"><a href="/admin/subscription">Subscription Plans</a></li></ul></nav> <div class="flex items-center space-x-5"><a class="hover:text-secondary hidden transition-colors md:block" href="/admin/profile">Account</a> <button class="hover:border-primary rounded-sm border border-transparent p-1 transition-colors">Logout</button></div></header> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> `);
  {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]-->`);
  pop();
}
function _layout($$payload, $$props) {
  push();
  const { children } = $$props;
  AdminNavbar($$payload);
  $$payload.out.push(`<!----> `);
  children?.($$payload);
  $$payload.out.push(`<!---->`);
  pop();
}
export {
  _layout as default
};
